@if (roleName == internal || companyName == 'Fonducar') {
<div class="container">
    <div class="header">
        <h1>Reporte de Evaluación de Seguridad</h1>
        <div class="subtitle">Evaluación de Infraestructura de Red - Fonducar</div>
        <div class="client-info">
            <div class="info-item">
                <span class="info-label">Cliente:</span>
                <span class="info-value">Fonducar</span>
            </div>
            <div class="info-item">
                <span class="info-label">Ubicación:</span>
                <span class="info-value">Cartagena, Colombia</span>
            </div>
            <div class="info-item">
                <span class="info-label">Fecha del Reporte:</span>
                <span class="info-value">19 de Septiembre, 2025</span>
            </div>
            <div class="info-item">
                <span class="info-label">Herramienta:</span>
                <span class="info-value">Framework de Evaluación Avanzada</span>
            </div>
            <div class="info-item">
                <span class="info-label">Dominio:</span>
                <span class="info-value">fcar.local</span>
            </div>
            <div class="info-item">
                <span class="info-label">Rango de Red:</span>
                <span class="info-value">10.0.1.0/24</span>
            </div>
        </div>
    </div>

    <div class="section dashboard-overview">
        <h2>Vista General del Dashboard</h2>
        <p class="dashboard-intro">El dashboard interactivo muestra una representación visual completa del estado de
            seguridad de la infraestructura de Fonducar basado en los datos reales de la evaluación.</p>

        <div class="dashboard-charts-main">
            <div class="chart-container-large">
                <apx-chart [series]="vulnerabilityChartOptions.series!" [chart]="vulnerabilityChartOptions.chart!"
                    [labels]="vulnerabilityChartOptions.labels!" [title]="vulnerabilityChartOptions.title!"
                    [fill]="vulnerabilityChartOptions.fill!" [yaxis]="vulnerabilityChartOptions.yaxis!"
                    [tooltip]="vulnerabilityChartOptions.tooltip!" [stroke]="vulnerabilityChartOptions.stroke!"
                    [colors]="vulnerabilityChartOptions.colors!" [legend]="vulnerabilityChartOptions.legend!"
                    [plotOptions]="vulnerabilityChartOptions.plotOptions!"></apx-chart>
                <div class="chart-title">Distribución de Vulnerabilidades</div>
            </div>
            <div class="chart-container-large">
                <apx-chart [series]="riskChartOptions.series!" [legend]="riskChartOptions.legend!"
                    [chart]="riskChartOptions.chart!" [labels]="riskChartOptions.labels!"
                    [colors]="vulnerabilityChartOptions.colors!" [grid]="riskChartOptions.grid!"
                    [fill]="riskChartOptions.fill!" [stroke]="riskChartOptions.stroke!"
                    [responsive]="riskChartOptions.responsive!"></apx-chart>
                <div class="chart-title">Análisis de Riesgo por Host</div>
            </div>
        </div>

        <div class="dashboard-metrics-grid">
            <div class="metric-card">
                <div class="metric-number critical">15</div>
                <div class="metric-label">Vulnerabilidades Críticas</div>
            </div>
            <div class="metric-card">
                <div class="metric-number high">30</div>
                <div class="metric-label">Vulnerabilidades Altas</div>
            </div>
            <div class="metric-card">
                <div class="metric-number medium">87</div>
                <div class="metric-label">Vulnerabilidades Medias</div>
            </div>
            <div class="metric-card">
                <div class="metric-number low">18</div>
                <div class="metric-label">Vulnerabilidades Bajas</div>
            </div>
        </div>

        <div class="summary-stats-row">
            <div class="summary-stat">
                <div class="summary-number">78</div>
                <div class="summary-label">Hosts Analizados</div>
            </div>
            <div class="summary-stat">
                <div class="summary-number">150</div>
                <div class="summary-label">Total Vulnerabilidades</div>
            </div>
            <div class="summary-stat">
                <div class="summary-number">45</div>
                <div class="summary-label">Críticas/Altas</div>
            </div>
        </div>
    </div>

    <!--div class="executive-summary">
        <h2>Resumen Ejecutivo</h2>
        <p>Se realizó una evaluación integral de seguridad en la infraestructura de red de Fonducar utilizando un
            <strong>framework de evaluación avanzada</strong> y un <strong>escáner de vulnerabilidades
                profesional</strong>. La evaluación identificó múltiples vectores de ataque críticos y vulnerabilidades
            que requieren atención inmediata.
        </p>

        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-number severity-critical">78</div>
                <div class="stat-label">Hosts Analizados</div>
            </div>
            <div class="stat-card">
                <div class="stat-number severity-critical">799</div>
                <div class="stat-label">Vulnerabilidades</div>
            </div>
            <div class="stat-card">
                <div class="stat-number severity-critical">45</div>
                <div class="stat-label">Vulns Críticas/Altas</div>
            </div>
            <div class="stat-card">
                <div class="stat-number severity-medium">2</div>
                <div class="stat-label">Herramientas de Análisis</div>
            </div>
        </div>

        <h4 style="color: var(--altair-primary); margin-bottom: 15px; font-family: var(--font-heading);">Distribución de
            Vulnerabilidades por Severidad</h4>
        <div class="vulnerability-distribution">
            <div class="vulnerability-stat">
                <div class="number critical-number">15</div>
                <div class="label">Críticas</div>
            </div>
            <div class="vulnerability-stat">
                <div class="number high-number">30</div>
                <div class="label">Altas</div>
            </div>
            <div class="vulnerability-stat">
                <div class="number medium-number">87</div>
                <div class="label">Medias</div>
            </div>
            <div class="vulnerability-stat">
                <div class="number low-number">18</div>
                <div class="label">Bajas</div>
            </div>
        </div>

        <div class="progress-bar">
            <div class="progress-fill" style="width: 35%;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 1rem; color: var(--altair-text);">Nivel de Riesgo General: <strong
                style="color: var(--altair-error);">CRÍTICO</strong> - Se requiere acción inmediata</p>
    </!--div>

    <div class="section">
        <h2>Hallazgos Críticos de Seguridad</h2>

        <h3 class="section-subtitle critical">Hallazgos de Evaluación Avanzada</h3>
        <div class="findings-grid">
            <div class="finding-card critical">
                <div class="finding-title">Credenciales de Dominio Comprometidas</div>
                <span class="badge badge-critical">Crítico</span>
                <div class="finding-description">
                    Se identificaron credenciales válidas para el usuario 'sistemas' del dominio fcar.local con
                    privilegios administrativos.
                </div>
                <div class="finding-details">
                    Usuario: fcar.local\sistemas
                    SID: S-1-5-21-586377569-559757091-1486468924-1150
                    Grupos: Administradores, VPN, Usuarios del dominio
                </div>
            </div>

            <div class="finding-card critical">
                <div class="finding-title">Acceso Administrativo a Sistemas Críticos</div>
                <span class="badge badge-critical">Crítico</span>
                <div class="finding-description">
                    El usuario comprometido tiene acceso administrativo a múltiples sistemas incluyendo el controlador
                    de dominio.
                </div>
                <div class="finding-details">
                    Sistemas afectados:
                    - DomainFcar.fcar.local (DC)
                    - ServerSQL.fcar.local
                    - ServerApp.fcar.local
                </div>
            </div>

            <div class="finding-card high">
                <div class="finding-title">Acceso FTP Anónimo</div>
                <span class="badge badge-high">Alto</span>
                <div class="finding-description">
                    Se detectó acceso FTP anónimo habilitado en uno o más sistemas de la red.
                </div>
                <div class="finding-details">
                    Usuario: anonymous
                    Contraseña: anonftp&#64;tool.com
                    Protocolo: FTP
                </div>
            </div>

            <div class="finding-card critical">
                <div class="finding-title">Enumeración Completa de Active Directory</div>
                <span class="badge badge-critical">Crítico</span>
                <div class="finding-description">
                    Se logró enumerar completamente la estructura de Active Directory obteniendo información sensible de
                    usuarios, grupos y servicios.
                </div>
                <div class="finding-details">
                    65 máquinas enumeradas
                    Información de SPNs obtenida
                    Estructura de DNS comprometida
                </div>
            </div>
        </div>

        <h3 class="section-subtitle critical">Hallazgos Escáner de Vulnerabilidades Professional</h3>
        <div class="findings-grid">
            <div class="finding-card critical">
                <div class="finding-title">Vulnerabilidades Críticas en Node.js</div>
                <span class="badge badge-critical">Crítico</span>
                <div class="finding-description">
                    15 vulnerabilidades críticas identificadas, principalmente en componentes Node.js con CVSS superior
                    a 9.0.
                </div>
                <div class="finding-details">
                    CVEs críticos: CVE-2024-27980, CVE-2024-27981
                    CVSS v3.0: 9.8 - 10.0
                    Host principal: 10.0.1.220
                    Total de hosts afectados: 8
                </div>
            </div>

            <div class="finding-card high">
                <div class="finding-title">Vulnerabilidades de Severidad Alta</div>
                <span class="badge badge-high">Alto</span>
                <div class="finding-description">
                    30 vulnerabilidades de severidad alta identificadas, principalmente relacionadas con Node.js y
                    componentes web.
                </div>
                <div class="finding-details">
                    CVEs destacados: CVE-2024-27982, CVE-2024-27983
                    CVSS v3.0: 8.1 - 8.2
                    Host principal: 10.0.1.220
                    Total de hosts afectados: 6
                </div>
            </div>

            <div class="finding-card medium">
                <div class="finding-title">Vulnerabilidades de Severidad Media</div>
                <span class="badge badge-medium">Medio</span>
                <div class="finding-description">
                    87 vulnerabilidades de severidad media distribuidas en múltiples hosts de la infraestructura.
                </div>
                <div class="finding-details">
                    Hosts más afectados:
                    - 10.0.1.249: 146 vulnerabilidades
                    - 10.0.1.253: 143 vulnerabilidades
                    - 10.0.1.220: 111 vulnerabilidades
                </div>
            </div>
        </div>
    </div>

    <div class="section">
        <h2>Análisis Detallado de Vulnerabilidades</h2>

        <h3 class="section-subtitle critical">Vulnerabilidades de Autenticación</h3>
        <div class="finding-card critical">
            <div class="finding-title">Autenticación NTLM Vulnerable</div>
            <div class="finding-description">
                El sistema utiliza autenticación NTLM que es susceptible a ataques de relay y cracking.
            </div>
        </div>

        <h3 class="section-subtitle high">Vulnerabilidades de Red</h3>
        <div class="finding-card high">
            <div class="finding-title">SMB Signing No Requerido</div>
            <div class="finding-description">
                La firma SMB no está configurada como requerida, permitiendo ataques de man-in-the-middle.
            </div>
        </div>

        <h3 class="section-subtitle medium">Exposición de Servicios</h3>
        <div class="finding-card medium">
            <div class="finding-title">Múltiples Servicios Expuestos</div>
            <div class="finding-description">
                Se identificaron múltiples servicios expuestos incluyendo RDP, SQL Server, LDAP y SMB.
            </div>
        </div>
    </div>

    <div class="section">
        <h2>Topología de Red Identificada</h2>
        <div class="network-topology">
            <h3>Controlador de Dominio</h3>
            <div class="host-item">
                <div class="host-name">DomainFcar.fcar.local</div>
                <div class="host-ip">10.0.1.253</div>
                <span class="badge badge-critical">Crítico</span>
            </div>

            <h3 style="margin-top: 20px;">Servidores de Aplicación</h3>
            <div class="host-list">
                <div class="host-item">
                    <div class="host-name">ServerSQL.fcar.local</div>
                    <div class="host-ip">10.0.1.251</div>
                </div>
                <div class="host-item">
                    <div class="host-name">ServerApp.fcar.local</div>
                    <div class="host-ip">10.0.1.252</div>
                </div>
                <div class="host-item">
                    <div class="host-name">ServerDigital.fcar.local</div>
                    <div class="host-ip">Múltiples interfaces</div>
                </div>
            </div>

            <h3 style="margin-top: 20px;">Estaciones de Trabajo (Muestra)</h3>
            <div class="host-list">
                <div class="host-item">
                    <div class="host-name">Gerente.fcar.local</div>
                    <div class="host-ip">Usuario ejecutivo</div>
                </div>
                <div class="host-item">
                    <div class="host-name">Sistemas.fcar.local</div>
                    <div class="host-ip">Administración IT</div>
                </div>
                <div class="host-item">
                    <div class="host-name">Contabilidad.fcar.local</div>
                    <div class="host-ip">Departamento financiero</div>
                </div>
                <div class="host-item">
                    <div class="host-name">RHumanos.fcar.local</div>
                    <div class="host-ip">Recursos humanos</div>
                </div>
            </div>
        </div>
    </div>

    <div class="section">
        <h2>Cronología de la Evaluación</h2>
        <div class="timeline">
            <div class="timeline-item">
                <div class="timeline-date">12 Sep 2025</div>
                <div class="timeline-event">Inicio de reconocimiento - Identificación inicial de hosts y servicios</div>
            </div>
            <div class="timeline-item">
                <div class="timeline-date">17 Sep 2025</div>
                <div class="timeline-event">Escaneo exhaustivo - Enumeración de vulnerabilidades y servicios</div>
            </div>
            <div class="timeline-item">
                <div class="timeline-date">19 Sep 2025</div>
                <div class="timeline-event">Análisis de Active Directory - Extracción de información privilegiada</div>
            </div>
        </div>
    </div>

    <div class="recommendations">
        <h2>Recomendaciones de Remediación</h2>

        <div class="recommendation-item">
            <span class="recommendation-priority priority-critical">CRÍTICA</span>
            <h3>Cambio Inmediato de Credenciales</h3>
            <p>Cambiar inmediatamente la contraseña del usuario 'sistemas' y implementar autenticación multifactor (MFA)
                para todas las cuentas administrativas.</p>
            <ul>
                <li>Resetear contraseña del usuario fcar.local\sistemas</li>
                <li>Implementar MFA en todos los accesos administrativos</li>
                <li>Auditar logs de acceso para actividad sospechosa</li>
            </ul>
        </div>

        <div class="recommendation-item">
            <span class="recommendation-priority priority-critical">CRÍTICA</span>
            <h3>Fortalecimiento de Active Directory</h3>
            <p>Implementar controles de seguridad adicionales en Active Directory para prevenir enumeración no
                autorizada.</p>
            <ul>
                <li>Configurar LDAP Signing como requerido</li>
                <li>Implementar filtros de consulta LDAP</li>
                <li>Habilitar auditoría de accesos a objetos del directorio</li>
            </ul>
        </div>

        <div class="recommendation-item">
            <span class="recommendation-priority priority-high">ALTA</span>
            <h3>Configuración de SMB Signing</h3>
            <p>Configurar SMB Signing como requerido en todos los sistemas para prevenir ataques de man-in-the-middle.
            </p>
        </div>

        <div class="recommendation-item">
            <span class="recommendation-priority priority-high">ALTA</span>
            <h3>Deshabilitación de FTP Anónimo</h3>
            <p>Deshabilitar el acceso FTP anónimo y migrar a protocolos seguros como SFTP o FTPS.</p>
        </div>

        <div class="recommendation-item">
            <span class="recommendation-priority priority-medium">MEDIA</span>
            <h3>Segmentación de Red</h3>
            <p>Implementar segmentación de red para limitar el movimiento lateral de atacantes.</p>
            <ul>
                <li>Separar servidores críticos en VLAN dedicada</li>
                <li>Implementar firewalls entre segmentos</li>
                <li>Configurar ACLs restrictivas</li>
            </ul>
        </div>
    </div>

    <div class="section">
        <h2>Métricas de Riesgo</h2>
        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-number severity-critical">95%</div>
                <div class="stat-label">Riesgo de Compromiso Total</div>
            </div>
            <div class="stat-card">
                <div class="stat-number severity-high">78</div>
                <div class="stat-label">Sistemas Accesibles</div>
            </div>
            <div class="stat-card">
                <div class="stat-number severity-medium">100%</div>
                <div class="stat-label">Cobertura de Escaneo</div>
            </div>
            <div class="stat-card">
                <div class="stat-number severity-low">0</div>
                <div class="stat-label">Controles de Seguridad Efectivos</div>
            </div>
        </div>
    </div>

    <div-- class="footer">
        <p>Este reporte es confidencial y está destinado únicamente para uso interno de Fonducar</p>
        <p>Generado por: Sistema ALTAIR ©</p>
        <p>Fecha de generación: 19 de Septiembre, 2025 - 16:28:20 UTC</p>
        <p style="margin-top: 20px; font-size: 0.9rem;">
            Para consultas técnicas o aclaraciones sobre este reporte, contacte al equipo de seguridad.
        </p>
    </div-->
</div>
}
